import { PageWrapper, useLayout } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { hocs as pageHocs } from 'modules/page';
import { memo, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { amplitudeService } from 'services/amplitude';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { pageConfig } from './config';
import { QBooksBudgets } from './resources/components/QBooksBudgets/QBooksBudgets';
import { XeroBudgets } from './resources/components/XeroBudgets/XeroBudgets';
import { useBreadcrumbs } from './resources/hooks/useBreadcrumbs';
import { useIntegrationTypeDecision } from './resources/hooks/useIntegrationTypeDecision';
import { usePageData } from './resources/hooks/usePageData';
import { messages } from './resources/messages';

export const Page = memo(() => {
    useLayout({ hasHeader: true, hasDrawer: true });

    useBreadcrumbs();

    const company = useCompanyBasedOnUrl();
    const integrationTypeDecision = useIntegrationTypeDecision();

    usePageData();

    useEffect(() => {
        amplitudeService.sendData('budgets: view list');
    }, []);

    const content = useMemo(() => {
        switch (integrationTypeDecision) {
            case domain.IntegrationType.Xero:
                return <XeroBudgets />;

            case domain.IntegrationType.QBooks:
                return <QBooksBudgets />;

            default:
                return null;
        }
    }, [integrationTypeDecision]);

    return (
        <PageWrapper>
            <Helmet
                title={messages.title({
                    companyName: company.displayName,
                })}
            />

            {content}
        </PageWrapper>
    );
});

export default pageHocs.withProtected({
    Page: Page,
    roles: pageConfig.access,
    integrationTypes: pageConfig.integrations,
});
